const redactedValue: string = '<redacted>';

const sensitivePayloadKeys: ReadonlyArray<string> = ['pin'];

const isPlainObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

/**
 * Redacts sensitive fields from an action payload before it is logged.
 *
 * The action itself is returned unchanged (same reference) unless its payload actually carries a
 * sensitive key, so this is a no-op for every other action in the store.
 */
const sanitizeAction = <A>(action: A): A => {
  if (!isPlainObject(action)) {
    return action;
  }

  const payload: unknown = action.payload;

  if (!isPlainObject(payload)) {
    return action;
  }

  const keysToRedact: ReadonlyArray<string> = sensitivePayloadKeys.filter(
    (key) => payload[key] !== undefined
  );

  if (keysToRedact.length === 0) {
    return action;
  }

  const sanitizedPayload: Record<string, unknown> = { ...payload };
  keysToRedact.forEach((key) => {
    sanitizedPayload[key] = redactedValue;
  });

  return { ...action, payload: sanitizedPayload } as A;
};

export default sanitizeAction;
